/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { runInAction } from 'mobx';

import { Dialog, Button, Typography } from 'primitives';
import { shareService, tracingService } from 'services';
import { notificationStore } from 'stores';

import shareStore from './share-store';

/**
 * DestroyLinkControl component
 * @param onCancel
 * @param closeParent
 * @returns {JSX.Element}
 */
export function DestroyLinkControl({ onCancel, closeParent } = { onCancel: () => {}, closeParent: () => {} }) {
  const { diagram } = shareStore.state;

  const handleError = (error) => {
    console.error(error);
    tracingService.traceError(error, 'Error removing share link');
    notificationStore.showError('Could not remove this share.');
  };

  const removeShare = () => {
    if (!diagram?.shareId) {
      handleError(new Error('Missing shareId or diagram'));
      return;
    }

    shareService
      .destroy(diagram.shareId)
      .then(() => {
        onCancel();
        closeParent();

        runInAction(() => {
          diagram.shareId = null;
          diagram.passwordProtected = false;
        });

        notificationStore.showSuccess('Shared link has been removed.');
      })
      .catch(handleError);
  };

  return (
    <>
      <Dialog.Header>
        <Dialog.Title data-test="share-title">Remove share link</Dialog.Title>
      </Dialog.Header>

      <Dialog.Content>
        {/* @ts-expect-error TS2741 */}
        <Typography>Remove public access by destroying the link. Anyone with the link will lose access.</Typography>
      </Dialog.Content>

      <Dialog.Footer>
        {/* @ts-expect-error TS2322 */}
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        {/* @ts-expect-error TS2322 */}
        <Button variant="danger-primary" onClick={removeShare} data-test="confirm-remove-button">
          Remove link
        </Button>
      </Dialog.Footer>
    </>
  );
}
